import { styled } from "styled-components";

const TagList = ({ items = [], variant = "default", className = "" }) => {
  if (!items || items.length === 0) return null;

  return (
    <List className={className}>
      {items.map((item, index) => (
        <Item key={`${item}-${index}`} data-variant={variant}>
          {item}
        </Item>
      ))}
    </List>
  );
};

export default TagList;

const List = styled.ul`
  margin-top: 1rem;
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  padding: 0;
  list-style: none;
`;

const Item = styled.li`
  font-size: 0.9rem;
  padding: 0.3rem 0.6rem;
  border: 1px solid #a8a29e;
  border-radius: 0.5rem;
  color: #a8a29e;
  text-transform: uppercase;
  font-style: italic;

  @media (max-width: 1024px) {
    font-size: 0.75rem;
  }

  /* 🔹 légère hiérarchie visuelle pour les rôles */
  &[data-variant="role"] {
    font-weight: 700;
    letter-spacing: 0.03em;
  }
`;
